/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkRemoveBrands} from '../api'

export const useMutationBulkRemoveBrands = createReactQueryMutationHook('bulkRemoveBrands', bulkRemoveBrands)
